import { render, staticRenderFns } from "./ExperienceCategoryPage.vue?vue&type=template&id=8281c34c&scoped=true"
import script from "./ExperienceCategoryPage.vue?vue&type=script&lang=js"
export * from "./ExperienceCategoryPage.vue?vue&type=script&lang=js"
import style0 from "./ExperienceCategoryPage.vue?vue&type=style&index=0&id=8281c34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8281c34c",
  null
  
)

export default component.exports